// components/DynamicTitle.js
import { useLocation } from "react-router-dom";
import { useTranslate } from "react-admin";
import { Helmet } from "react-helmet-async";

const getResourceFromPath = (pathname) => {
  const match = pathname.match(/^\/([^/]+)/);
  if (!match) return null;

  const resource = match[1].replace(/-/g, "_");
  return resource;
};

const DynamicTitle = () => {
  const location = useLocation();
  const translate = useTranslate();

  const resource = getResourceFromPath(location.pathname);
  const translatedTitle = resource
    ? translate(`resources.${resource}.name`, { _: resource })
    : "Acura App";

  return (
    <Helmet>
      <title>{`${translatedTitle}`}</title>
    </Helmet>
  );
};

export default DynamicTitle;
